<template>
    <CardPage :section="2" :page="12" :nextDisabled="nextDisabled">
        <p>Pick four of the fun facts below to create your own bio.</p>
        <div
            v-for="(key, index) in factsOrder"
            :key="index"
            class="px-2 py-1 mb-1"
            @click="select(facts[key])"
            :class="{ secondary: !facts[key].selected, 'primary white--text': facts[key].selected }"
            v-ripple
        >
            {{ facts[key].question }}
        </div>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        facts: get('section2/facts'),
        factsOrder: get('section2/factsOrder')
    },
    methods: {
        nextDisabled() {
            return !this.$store.get('section2/maxFactsSelected');
        },
        select(fact) {
            this.$store.commit('section2/selectFact', fact);
        }
    }
};
</script>
